import { gql } from "@apollo/client";

export const GET_POINT_HISTORY = gql`
  query getPointHistory($pagination: PaginationInputType!, $filter: FieldFilterInputType) {
    getPointHistory(pagination: $pagination, filter: $filter) {
      pointHistory {
        id
        amount
        type
        createdAt
        User {
          username
          firstName
          lastName
          email
        }
      }
      total
    }
  }
`;